module.exports = __webpack_public_path__ + "static/media/5.ac52c6ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/trolls-girl/barrette/5.png
// module id = 87
// module chunks = 0